// Design System Colors & Spacing
export const colors = {
  bg: "#0f0f0f",
  accent: "#01ff9a",
  accentSecondary: "#acffe5",
  cardBg: "rgba(255,255,255,0.03)",
  cardBorder: "rgba(255,255,255,0.08)",
  textPrimary: "#ffffff",
  textSecondary: "rgba(255,255,255,0.6)",
  textMuted: "rgba(255,255,255,0.4)",
  onTrack: "#01ff9a",
  overshoot: "#f97316",
  undershoot: "#3b82f6",
};

// Premium card shadow for floating effect
export const cardShadow = "0px 10px 30px rgba(0,0,0,0.35)";
